
import { Swiper, Autoplay, Navigation, Pagination, Thumbs } from "swiper";
import "swiper/swiper-bundle.min.css";

export default {
  props: ["staffs"],
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      mediaUrl: this.$config.BASE_URL_RESOURCE,
      swiper: {},
    };
  },
  mounted() {
    Swiper.use([Autoplay, Thumbs, Navigation, Pagination]);

    const windowWidth = window.innerWidth;
    let itemToShow = 6;

    if (windowWidth <= 500) {
      itemToShow = 2;
    } else if (windowWidth <= 700) {
      itemToShow = 3;
    } else if (windowWidth <= 900) {
      itemToShow = 4;
    } else if (windowWidth <= 1100) {
      itemToShow = 5;
    }

    this.swiper = new Swiper(".ppSwiper", {
      spaceBetween: 48,
      slidesPerView: itemToShow,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      observer: true,
      observeParents: true,
    });
  },
  watch: {
    swiper(oldValue, newValue) {
      if (oldValue.enabled) {
        oldValue.update();
      }
    },
  },
};
